import React from 'react';
import { useSelector } from 'react-redux';
// import { client }  from '../OwnWebsocket';
// import {useNavigate} from "react-router-dom";
// import Player from '@vimeo/player';
import Tracking from './Tracking';

function Screen() { 
  var ScreenData = "";

  const videoIframe = useSelector((state) => state.HomeBucket.bucket.data.video);
  const videoAccess = useSelector((state) => state.HomeBucket.bucket.data.video_access);

  if(videoIframe){
    // if(videoAccess==="no"){
    //   ScreenData = () => <div className="request-box 11"><h3>You are not enrolled for this event<a href="https://ciisummit.com/registrations2022/" className="request_access_anchor" target="_blank">Enrol Now</a></h3></div>;
    // }else{
      ScreenData = () => <div dangerouslySetInnerHTML={{__html: videoIframe}} />;
    //}
  }else{
      ScreenData =  () => "";
  }
    return (
    <>
      <div className="live-frame">  
           <ScreenData />

           <Tracking />
        </div>
    </>
    );
}

  
  
  export default Screen;